module.exports = __webpack_public_path__ + "media/St 4-Question 15-correct.0bbe94c4.wav";